export default {
  brands: {
    theme: "brands"
  },
  default: {
    theme: "default"
  }
}
